(function () {
  if (window.__yukoDrReuterMinOrderGuard) return;
  window.__yukoDrReuterMinOrderGuard = true;

  var THRESHOLDS = { CHF: 110, EUR: 84 };

  function findProductAddAnchor() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;
    var btn = form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    if (!btn) return null;
    var container = btn.closest('.product-form__buttons') || btn.parentNode;
    if (!container || !container.parentNode) return null;
    return container;
  }

  function isProductPage() {
    return !!findProductAddAnchor();
  }

  function getThreshold(currency) {
    return Object.prototype.hasOwnProperty.call(THRESHOLDS, currency) ? THRESHOLDS[currency] : null;
  }

  function formatAmount(amount, currency) {
    return amount.toFixed(2) + ' ' + currency;
  }

 function buildNudgeMessage(remaining, currency) {
    return 'Legen Sie bitte noch ' + formatAmount(remaining, currency) + ' an Warenwert in den Einkaufskorb um den Mindestbestellwert von ' +
      formatAmount(THRESHOLDS[currency], currency) + ' zu erreichen.';
  }


  function fetchCartState() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var currency = cart && cart.currency;
        var originalTotalCents = cart && typeof cart.original_total_price === 'number' ? cart.original_total_price : null;
        if (!currency || originalTotalCents == null) return null;
        return { currency: currency, originalTotal: originalTotalCents / 100 };
      })
      .catch(function () { return null; });
  }

  function evaluateMinimum(state) {
    if (!state) return { below: false, remaining: 0, currency: null };
    var threshold = getThreshold(state.currency);
    if (threshold == null) return { below: false, remaining: 0, currency: state.currency };
    var below = state.originalTotal < threshold;
    return { below: below, remaining: below ? threshold - state.originalTotal : 0, currency: state.currency };
  }

  function getMessageStyles() {
    return 'background-color:#FFD466;color:#4A4A4A;font-size:14px;text-align:left;' +
      'padding:8px 12px;margin-top:8px;border-radius:4px;font-weight:600;' +
      'display:block;box-sizing:border-box;width:auto;max-width:100%;';
  }

  function upsertMinOrderMessage(container, msg, insertFn) {
    var existing = container.querySelector('[data-yuko-min-order-message]');
    if (msg == null) {
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      return;
    }
    if (existing) {
      if (existing.textContent !== msg) existing.textContent = msg;
      return;
    }
    var el = document.createElement('div');
    el.setAttribute('data-yuko-min-order-message', '1');
    el.setAttribute('role', 'alert');
    el.style.cssText = getMessageStyles();
    el.textContent = msg;
    insertFn(el);
  }

  function evaluateProductPage(result) {
    var anchor = findProductAddAnchor();
    if (!anchor) return;
    var host = anchor.parentNode;
    if (!result.below) {
      upsertMinOrderMessage(host, null);
      return;
    }
    var msg = buildNudgeMessage(result.remaining, result.currency);
    upsertMinOrderMessage(host, msg, function (el) {
      host.insertBefore(el, anchor.nextSibling);
    });
  }

  function gateCheckoutButtons(result) {
    var buttons = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.disabled = result.below;
      var ctas = btn.closest('.cart__ctas');
      var host = ctas ? ctas.parentNode : btn.parentNode;
      if (!result.below) {
        upsertMinOrderMessage(host, null);
        continue;
      }
      var msg = buildNudgeMessage(result.remaining, result.currency);
      upsertMinOrderMessage(host, msg, (function (ctas, host) {
        return function (el) {
          if (ctas) {
            host.insertBefore(el, ctas);
          } else {
            host.appendChild(el);
          }
        };
      })(ctas, host));
    }
  }

  function gateExpressCheckout(result) {
    var wrappers = document.querySelectorAll('.cart__dynamic-checkout-buttons, .wallet-button-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      var el = wrappers[i];
      if (result.below) {
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.4';
        el.setAttribute('aria-disabled', 'true');
      } else {
        el.style.pointerEvents = '';
        el.style.opacity = '';
        el.removeAttribute('aria-disabled');
      }
    }
  }

  function run() {
    fetchCartState().then(function (state) {
      var result = evaluateMinimum(state);
      gateCheckoutButtons(result);
      gateExpressCheckout(result);
      if (isProductPage()) evaluateProductPage(result);
    });
  }

  function init() {
    run();
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', run);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
